import { defaultNS, namespaces as ns, resources } from './resources';

import format from './format';
export const config = {
  lng: 'en',
  ns,
  defaultNS,
  resources,
  interpolation: {
    escapeValue: false, // react already escapes true causes double escape
    format,
  },
};

export default config;
